/* src/app/ship/ship-electronic-export/ship-electronic-export.component.scss */
.ship-electronic-export {
  width: 100%;
}
.ship-electronic-export .form-section-header {
  margin-bottom: 0 !important;
}
.ship-electronic-export .select-wrapper {
  position: relative;
}
.ship-electronic-export .eei-message {
  font-weight: 700;
  margin-bottom: 1em;
}
.ship-electronic-export .mat-form-field-should-float .mrn-input + img {
  transition: all 0.25s ease;
  transform: translateY(-1.28125em) scale(0.75) perspective(100px) translateZ(0.001px);
  top: 0.25rem;
  left: 10.1rem;
}
.ship-electronic-export .mrn-input {
  text-transform: uppercase;
  position: relative;
}
.ship-electronic-export .mrn-input + img {
  position: absolute;
  top: 0.4rem;
  left: 14rem;
}
.ship-electronic-export .power-of-attorney-content {
  width: 100%;
  height: 20em;
  overflow-y: scroll;
  padding: 1em;
  border: solid thin gray;
}
.ship-electronic-export .help-icon {
  width: 15px;
  height: 15px;
  margin: 0 0.5em;
}
/*# sourceMappingURL=ship-electronic-export.component.css.map */
